export const CLI_KIT_VERSION = '3.58.2'
